import React from 'react';

export default function PullQuoteConfig({ data, onChange }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <>
      <div className="adminblog-field">
        <label>Quote</label>
        <textarea value={data.quote || ''} onChange={(e) => update('quote', e.target.value)} placeholder="The quote text..." rows={4} />
      </div>
      <div className="adminblog-field">
        <label>Attribution</label>
        <input type="text" value={data.attribution || ''} onChange={(e) => update('attribution', e.target.value)} placeholder="Author name or source" />
      </div>
      <div className="adminblog-field">
        <label>Style</label>
        <div className="adminblog-status-toggle">
          {[{ value: 'border-left', label: 'Border Left' }, { value: 'centered', label: 'Centered' }].map(opt => (
            <button
              key={opt.value}
              className={`adminblog-status-option ${(data.style || 'border-left') === opt.value ? 'active' : ''}`}
              onClick={() => update('style', opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
